export default {
  auth: {
    tokenRefresh: 'tokenRefresh',
    signIn: 'signin',
    signUp: 'signup',
    passwordReset: 'passwordReset',
    passwordResetConfirm: 'passwordResetConfirm',
  },
  shelf: {
    preview: 'shelf/file/{{fileOguid}}/page/{{page}}',
    upload: 'shelf',
  },
  users: {
    current: 'user',
    generateAPIKey: 'generateAPIKey',
    settings: 'user/settings',
  },
  envelopes: {
    list: 'envelopes',
    envelope: 'boxes/{{ boxOguid }}/envelopes/{{ envelopeOguid }}',
    generateSignLink: 'envelopes/generateSignLink',
    flowStop: 'envelopes/{{ envelopeOguid }}/flowStop',
    todos: 'envelopes/{{ envelopeOguid }}/todos',
    signing: {
      doHash: 'envelopes/{{ envelopeOguid }}/files/{{ fileIndex }}/doHash',
      doSign: 'envelopes/{{ envelopeOguid }}/files/doSign',
    },
    exportExcel: 'envelopes/exportExcel'
  },
  mandates: {
    list: '/users/mandates',
    listBox: '/boxes/{{ boxOguid }}/mandates',
    create: '/mandates',
    single: '/mandates/{{ oguid }}',
  },
  metadata: {
    locales: 'locales',
    timeZones: 'timeZones',
  },
  verify: {
    confirm: 'verify/phoneCheckConfirm',
    init: 'verify/phoneCheckInit',
  },
  shared: {
    getDocumentFile:
      '/shared/{{ sharedLinkOguid }}/envelope/file/{{ fileIndex }}/type/{{ fileType }}',
    getDocumentReview:
      '/shared/{{ sharedLinkOguid }}/envelope/file/{{ fileIndex }}/page/{{ page }}',
    generateShare: '/envelopes/{{ envelopeOguid }}/generateShare',
  },
  boxes: {
    webHookIntegration: '/boxes/{{ boxOguid }}/webHookIntegration',
    boxes: '/boxes',
    changeBox: '/boxes/{{ boxOguid }}',
    getLogo: '/logo/boxes/{{ boxOguid }}',
    changeLogo: '/boxes/{{ boxOguid }}/logo',
    users: {
      list: '/boxes/{{ boxOguid }}/users',
      change: '/boxes/{{ boxOguid }}/users/{{ userBoxOguid }}',
    },
    invites: {
      list: '/boxes/{{ boxOguid }}/invites',
      create: '/boxes/{{ boxOguid }}/userInvite',
      repeat: '/boxes/{{ boxOguid }}/invitesRepeat',
      change: '/boxes/{{ boxOguid }}/invites/{{ inviteOguid }}',
    },
  },
  tasks: {
    markIsRead: '/tasks/markIsRead',
    decline: '/tasks/{{ taskOguid }}/decline',
    selfie: '/tasks/{{ taskOguid }}/selfie',
  }
};
